import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../../actions';
import { Content } from '../layout';
import { pageLimit as limit } from '../../config/keys';
// import Pagination from "../common/Pagination";
import { fabStyle } from '../common/style';

const UserList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.user.users);

  useEffect(() => {
    dispatch(fetchUsers(page, limit));
  }, [dispatch, page]);

  const navigateToUserDetail = (id) => {
    navigate(`${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderUsers = () => {
    return rows.map((row) => (
      <TableRow
        key={row.id}
        onClick={() => navigateToUserDetail(row.id)}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>{row.id}</TableCell>
        <TableCell>{row.username}</TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.type.name}</TableCell>
        <TableCell>
          {row.type !== 3 && row.Organization && row.Organization.displayName}
        </TableCell>
        <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));
  };

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            사용자 목록
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="user-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>사용자 아이디</TableCell>
                  <TableCell>이름</TableCell>
                  <TableCell>유형</TableCell>
                  <TableCell>건설사</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderUsers()}</TableBody>
            </Table>
            {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          </TableContainer>
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default UserList;
